export default __webpack_public_path__ + "static/1-1673a086318d8a6bbd796a20ff220598.jpg";